import _ from 'lodash';
import { isNavItemShown } from 'config/helpers';

import { Main } from 'components/landing/pages/main';
import { Services } from 'components/landing/pages/services';
import { Pricing } from 'components/landing/pages/pricing';
import { Careers } from 'components/landing/pages/careers';
import { Offer } from 'components/landing/pages/offer';
import { Login } from 'components/landing/pages/login';
import Blog from 'components/core/blog/Blog';

import config from 'config/careers';

const authRedirect = {
  exact: true,
  path: '/api/auth/google_login',
  component: Login,
  redirect: '/signup',
  props: {
    nameProp: {
      error: {
        step: 0,
        msg: '<p>Oops, there was an error in communications between our back-end and the Google server.<br/>Our engineers will look into that.<br/>Try again.</p>',
      },
    },
  },
};

const offers = config.contentBlocks.offers.blocks.map((offer) => ({
  exact: true,
  path: `/careers/${offer.url}`,
  component: Offer,
  props: { ...offer },
}));

const routes = [
  {
    exact: true,
    path: '/',
    transition: true,
    component: Main,
  },
  {
    exact: true,
    path: '/services',
    transition: true,
    component: Services,
  },
  {
    exact: true,
    path: '/pricing',
    transition: true,
    component: Pricing,
  },
  {
    exact: true,
    path: '/careers',
    transition: true,
    component: Careers,
  },
  {
    exact: true,
    path: '/blog/:blog_title?',
    transition: true,
    component: Blog,
  },
  {
    exact: true,
    path: '/login',
    transition: true,
    component: Login,
  },
  {
    exact: true,
    path: '/signup',
    transition: true,
    component: Login,
  },
  authRedirect,
  ...offers,
];

export default _.filter(routes, isNavItemShown);



// WEBPACK FOOTER //
// ./src/components/landing/routes.js